import {Box, FormControl, NativeSelect, Pagination, PaginationItem} from '@mui/material'
import {ChangeEvent, useCallback, useMemo} from 'react'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore'
import {useControlledFilterTableContainerProps} from './ControlledFilterTableContainer'
import {useControlledFilterTableHelpers} from './useControlledFilterTableUtils'

export const ControlledFilterTablePagination = () => {
  const {filters, onFilter, searchResults, id} = useControlledFilterTableContainerProps()
  const {setPageNumber, setPageSize} = useControlledFilterTableHelpers({filters, onFilter})

  const handlePaginationChange = useCallback(
    (e: ChangeEvent<unknown>, pageNumber: number) => {
      setPageNumber(pageNumber)
    },
    [setPageNumber]
  )

  const pageCount = useMemo(() => {
    if (searchResults) {
      const count = Math.ceil(searchResults.total / searchResults.limit)
      return count
    }
    return 0
  }, [searchResults])

  const handlePageSizeChange = useCallback(
    (e: ChangeEvent<HTMLSelectElement>) => {
      setPageSize(parseInt(e.target.value))
    },
    [setPageSize]
  )

  if (!filters || !searchResults) {
    return null
  }

  return (
    <Box sx={{display: 'flex', justifyContent: 'end', py: 1, px: 1}}>
      <FormControl size='small'>
        <NativeSelect
          id={id && `${id}-input-page-size`}
          onChange={handlePageSizeChange}
          value={filters.limit || PAGE_SIZE_OPTIONS[0]}
        >
          {PAGE_SIZE_OPTIONS.map((size) => (
            <option key={size} value={size}>
              {size}
            </option>
          ))}
        </NativeSelect>
      </FormControl>
      <Pagination
        renderItem={(item) => (
          <PaginationItem
            id={id && `${id}-button-navigate-page-${item.page}`}
            slots={{previous: NavigateBeforeIcon, next: NavigateNextIcon}}
            {...item}
          />
        )}
        count={pageCount}
        onChange={handlePaginationChange}
      />
    </Box>
  )
}

const PAGE_SIZE_OPTIONS = [10, 25, 50, 100]
